import { ApiResponse } from '@marketplace-web/shared/api-client'
import { api } from 'data/api/api'

import { UpdateFeedbackRatingOptionsArgs } from '../types/feedback-rating'
import { updateFeedbackRatingOptionsArgsToParams } from '../transformers/update-feedback-rating-options-args-to-params'

export const updateFeedbackRatingOptions = (
  userId: number,
  conversationId: number | string,
  args: UpdateFeedbackRatingOptionsArgs,
) =>
  api.put<ApiResponse>(
    `/users/${userId}/msg_threads/${conversationId}/feedback_ratings`,
    updateFeedbackRatingOptionsArgsToParams(args),
  )
